import ot from './ot'
import yt from './yt'

export default [ot, yt].flat()
